import { Dialog, DialogContent, DialogProps, DialogTitle } from "@mui/material";
import React from "react";
import { ChargeCategory } from "../../Objects/ChargeCategory";
import { ChargeCategoryForm } from "../molecules/ChargeCategoryForm";
import { useSnackbar } from "notistack";
import { regChargeCategory } from "../../Api/Store";
import { ApiError } from "../../Api/ApiError";

export interface ChargeCategoryEditDialogProps {
    onClose: () => void
    dialogProps?: Omit<DialogProps, "open">
    chargeCategory?: ChargeCategory
}
export function ChargeCategoryEditDialog({
    onClose,
    dialogProps,
    chargeCategory,
}: ChargeCategoryEditDialogProps): React.ReactElement {
    const { enqueueSnackbar } = useSnackbar()
    const [editChargeCategory, setEditChargeCategory] = React.useState<ChargeCategory>()
    const [open, setOpen] = React.useState<boolean>(false)

    React.useEffect(() => {
        if (chargeCategory !== undefined) {
            setEditChargeCategory(chargeCategory)
            setOpen(true)
        }
    }, [chargeCategory])


    const doSubmit = React.useCallback((chargeCategory: ChargeCategory) => {
        console.log(chargeCategory)
        regChargeCategory({
            categoryCharge: chargeCategory
        }).then(() => {
            enqueueSnackbar("登録しました", { variant: "success" })
            setOpen(false)
            onClose()
        }).catch((e: any) => {
            if (e.__CANCEL__) {
                console.info("canceled")
            } else if (e instanceof ApiError) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else if (e instanceof Error) {
                enqueueSnackbar(e.message, { variant: "error" })
            } else {
                enqueueSnackbar("通信に失敗しました", { variant: "error" })
            }
        })

    }, [enqueueSnackbar, onClose])

    return (
        <Dialog
            {...dialogProps}
            open={open}
            onClose={() => {
                setOpen(false)
                onClose()
            }}
            fullWidth
        >
            <DialogTitle>料金カテゴリー設定</DialogTitle>
            <DialogContent>
                <ChargeCategoryForm
                    chargeCategory={editChargeCategory}
                    onSubmit={doSubmit}
                    onCancel={() => {
                        setOpen(false)
                        onClose()
                    }}
                />
            </DialogContent>
        </Dialog>
    )
}